import * as fileUploadApi from '../api/file-upload'
import * as attachmentApi from '../api/attachment'
import { handleApiError } from './api-errors'

export const UPLOAD_STARTED = 'UPLOAD_STARTED'
export const UPLOAD_COMPLETE = 'UPLOAD_COMPLETE'
export const UPLOAD_FAILED = 'UPLOAD_FAILED'

export const SAVE_ATTACHMENT = 'SAVE_ATTACHMENT'
export const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT'

export const uploadAttachment = (fileObj) => (dispatch) => {
    dispatch({ type: UPLOAD_STARTED })

    fileUploadApi
        .uploadFile(fileObj)
        .then((fileId) => {
            dispatch({
                type: UPLOAD_COMPLETE,
                payload: fileId,
            })
        })
        .catch((err) => {
            dispatch({
                type: UPLOAD_FAILED,
                payload: err,
            })
        })
}

// export const downloadAttachment = (idea_id, urlFileId) => (dispatch) => {
//     fileUploadApi
//         .downloadFile(urlFileId)
//         .catch((err) => dispatch(handleApiError(err)))
// }

export const saveAttachmentWithIdea = (idea_id, fileName, fileId) => (dispatch) => {
    attachmentApi
        .putObj(idea_id, {
            name: fileName,
            url: fileId,
        })
        .then((res) => {
            dispatch({ type: SAVE_ATTACHMENT, payload: res })
        })
        .catch((err) => dispatch(handleApiError(err)))
}

export const deleteAttachmentFromIdea = (idea_id, _id) => (dispatch) => {
    // For now, we're only deleting the reference to the file.
    // TODO delete the file in S3

    attachmentApi
        .deleteObj(idea_id, _id)
        .then((res) => {
            dispatch({ type: DELETE_ATTACHMENT, payload: res })
        })
        .catch((err) => dispatch(handleApiError(err)))
}
